// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by SideBar.js which is called by ServiceInventoryPage.js file, CsVersionPage.js file, PltVersionPage.js file.
*/

.sidebar {
  width: 4%;
  min-height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: #0c3135;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px !important;  
  border-radius: 18px;
}

.sidebar button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.sidebar button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.sidebar button.active {
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.sidebar button svg {
  width: 20px;
  height: 20px;
}

.sidebar button::before {
  content: attr(data-tooltip);
  position: absolute;
  top: 100%;         
  left: 140%;          
  transform: translateX(-50%); 
  margin-top: 8px;    
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  white-space: nowrap;
  z-index: 1000;      
}

.sidebar button:hover::before {
  opacity: 1;
  visibility: visible;
}

@media (max-width:321px) {
  .sidebar{
    width:12vw;
    
  }
  .sidebar button{
    width: 10vw;
    height: 5vh;
    margin-top: 90%;
  }
}

@media (min-width: 321px) and (max-width: 376px)  {
  .sidebar{
    width:12vw;
  }
  .sidebar button{
    width: 10vw;
    height: 5vh;
    margin-top: 90%;
  }
}

@media  (min-width: 376px) and (max-width: 426px)  {
  .sidebar{
    width:11vw;
  }
  .sidebar button{
    width: 8vw;
    height: 5vh;
    margin-top: 90%;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .sidebar{
    width:7vw;
  }
  .sidebar button{
    width: 5vw;
    height: 5vh;
    margin-top: 90%;
  }
}

@media (min-width: 769px) and (max-width: 1025px) {
  .sidebar{
    width:4vw;
  }
  .sidebar button{
    width: 4vw;
    height: 5vh;
    margin-top: 90%;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .sidebar{
    width:4vw;
  }
  .sidebar button{
    width: 3vw;
    height: 5vh;
    margin-top: 10%;
  }
}

@media (min-width: 1441px) and (max-width: 1921px) {
  .sidebar{
    width:4vw;
  }
  .sidebar button{
    width: 3vw;
    height: 4vh;
    margin-top: 20%;
  }
}

@media (min-width: 1921px){
  .sidebar{
    width:4vw;
  }
  .sidebar button{
    width: 3vw;
    height: 5vh;
    margin-top: 40%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/SideBar.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,OAAO;EACP,MAAM;EACN,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;;EAEZ;EACA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/*\nThis style file is imported by SideBar.js which is called by ServiceInventoryPage.js file, CsVersionPage.js file, PltVersionPage.js file.\n*/\n\n.sidebar {\n  width: 4%;\n  min-height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: #0c3135;\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px !important;  \n  border-radius: 18px;\n}\n\n.sidebar button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n}\n\n.sidebar button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.sidebar button.active {\n  background: rgba(255, 255, 255, 0.25);\n  border: 2px solid rgba(255, 255, 255, 0.5);\n}\n\n.sidebar button svg {\n  width: 20px;\n  height: 20px;\n}\n\n.sidebar button::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  top: 100%;         \n  left: 140%;          \n  transform: translateX(-50%); \n  margin-top: 8px;    \n  padding: 5px 10px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  border-radius: 4px;\n  font-size: 12px;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  z-index: 1000;      \n}\n\n.sidebar button:hover::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n@media (max-width:321px) {\n  .sidebar{\n    width:12vw;\n    \n  }\n  .sidebar button{\n    width: 10vw;\n    height: 5vh;\n    margin-top: 90%;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 376px)  {\n  .sidebar{\n    width:12vw;\n  }\n  .sidebar button{\n    width: 10vw;\n    height: 5vh;\n    margin-top: 90%;\n  }\n}\n\n@media  (min-width: 376px) and (max-width: 426px)  {\n  .sidebar{\n    width:11vw;\n  }\n  .sidebar button{\n    width: 8vw;\n    height: 5vh;\n    margin-top: 90%;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .sidebar{\n    width:7vw;\n  }\n  .sidebar button{\n    width: 5vw;\n    height: 5vh;\n    margin-top: 90%;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n  .sidebar{\n    width:4vw;\n  }\n  .sidebar button{\n    width: 4vw;\n    height: 5vh;\n    margin-top: 90%;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .sidebar{\n    width:4vw;\n  }\n  .sidebar button{\n    width: 3vw;\n    height: 5vh;\n    margin-top: 10%;\n  }\n}\n\n@media (min-width: 1441px) and (max-width: 1921px) {\n  .sidebar{\n    width:4vw;\n  }\n  .sidebar button{\n    width: 3vw;\n    height: 4vh;\n    margin-top: 20%;\n  }\n}\n\n@media (min-width: 1921px){\n  .sidebar{\n    width:4vw;\n  }\n  .sidebar button{\n    width: 3vw;\n    height: 5vh;\n    margin-top: 40%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
